import { Component, OnInit } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';
import { PriceWithCurrency } from 'models';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
    selector: 'app-currency-select',
    template: require('./currency-select.component.html'),
    styles: [require('./currency-select.component.scss')],
    host: { class: "" },
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class CurrencySelectComponent implements OnInit {

    ngOnInit(): void {
    }

    @Output() priceWithCurrency = new EventEmitter<PriceWithCurrency>();

    //@Input() set amount(value: string) {
    //    this.selectedCurrency = value.charAt(0);
    //    this.amount = Number(value.substring(1, value.length - 1));
    //}
    
    @Input() amount: number;
    @Input() selectedCurrency: string = '£';

    selectChangeHandler(event: any) {
        this.selectedCurrency = event.target.value;
        this.priceWithCurrency.emit(new PriceWithCurrency({ currency: this.selectedCurrency, price: this.amount}));
    }

    priceChange(value) {
        this.priceWithCurrency.emit(new PriceWithCurrency({ currency: this.selectedCurrency, price: this.amount }));
    }

}